import { render, staticRenderFns } from "./lrResult.vue?vue&type=template&id=6397f155&scoped=true"
import script from "./lrResult.vue?vue&type=script&lang=js"
export * from "./lrResult.vue?vue&type=script&lang=js"
import style0 from "./lrResult.vue?vue&type=style&index=0&id=6397f155&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_react-dom@19.2.4_react@18.3.1_vue-templat_zb2mrinni5lndihrytzfraeym4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397f155",
  null
  
)

export default component.exports